/**
 * 마이페이지 트리 메뉴 — "계약 관리" 자식 3개
 * - 부모 행 바로 아래에 인라인으로 노출
 * - 회색 박스 없이 자연스럽게 트리 라인만
 * - 마지막 자식의 라인은 ㄴ 모양으로 끊김
 */
import chevironRight from "$/cheviron-right.svg";

interface Props {
  history: { push: (to: string) => void };
}

const ITEMS = [
  { label: "계약 현황", to: "/business/layout/contract-status" },
  { label: "계약서 양식", to: "/business/layout/contract-templates" },
  { label: "도장 관리", to: "/business/layout/seal-management" },
];

export const ContractTreeChildren = ({ history }: Props) => {
  return (
    <div className="relative ml-4 my-1">
      {/* 자식 그룹 좌측 수직 액센트 바 (옅은 주황) */}
      <span
        aria-hidden
        className="absolute left-0 top-1.5 bottom-1.5 w-[2px] bg-[#FFD9A3] rounded-full"
      />
      {ITEMS.map((it) => (
        <button
          key={it.label}
          className="flex justify-between items-center pl-4 pr-4 py-1.5 w-full text-[13px] hover:bg-[#FFFBF0] rounded-r-lg"
          onClick={() => history.push(it.to)}
        >
          <span className="text-[#555]">{it.label}</span>
          <img src={chevironRight} alt={it.label} className="opacity-60" />
        </button>
      ))}
    </div>
  );
};
